import { render, staticRenderFns } from "./BulletinGalleryComponent.vue?vue&type=template&id=1900c6bf&scoped=true&"
import script from "./BulletinGalleryComponent.vue?vue&type=script&lang=js&"
export * from "./BulletinGalleryComponent.vue?vue&type=script&lang=js&"
import style0 from "./BulletinGalleryComponent.vue?vue&type=style&index=0&id=1900c6bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1900c6bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1900c6bf')) {
      api.createRecord('1900c6bf', component.options)
    } else {
      api.reload('1900c6bf', component.options)
    }
    module.hot.accept("./BulletinGalleryComponent.vue?vue&type=template&id=1900c6bf&scoped=true&", function () {
      api.rerender('1900c6bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/bulletin/BulletinGalleryComponent.vue"
export default component.exports